import React, { useRef, useEffect } from 'react';
import { useFirstRender } from 'react-haiku';

import Show from 'components/Show';
import Message from 'components/Messenger/Chat/Message';

const Messages = ({ userId, messages }) => {
	// Store message bottom ref
	const bottom = useRef(null);

	// Store first render flag
	const isFirst = useFirstRender();

	// Scroll to botom on message change
	useEffect(() => {
		isFirst
			? bottom?.current?.scrollIntoView()
			: bottom?.current?.scrollIntoView({
				behavior: 'smooth'
			});
	}, [isFirst, messages]);

	return (
		<div className="py-3 px-3 flex-1 space-y-2 overflow-y-auto">
			<Show if={messages?.length}>
				{messages?.map((message, idx) =>
					<Message key={message.id} userId={userId} message={message} idx={idx} />
				)}
			</Show>

			<div ref={bottom} />
		</div>
	);
};

export default Messages;